import './public-path'
import 'react-app-polyfill/stable';
import dva from 'dva';
import leaveMsg from "./models/leaveMsg";
import { headersLanguageKey } from './utils/index';
import Cookies from 'js-cookie'
import './services/base';
import './index.css';
const createHistory = require("history").createBrowserHistory;

// 设置默认语言
window[headersLanguageKey] = 'zh'

window.urlObject = {};
const urlSearch = decodeURIComponent(window.location.search || '')

urlSearch.replace(/([^?&=]+)=([^&]+)/g,(_,k,v)=> {
  window.urlObject[k]=v;
  const lowerCaseK = k?.toLocaleLowerCase()
  window.urlObject[lowerCaseK] = v
});

// 访客端种cookie
if (window.urlObject?.sysNum) {
  const domain = window.location.hostname.split('.').slice(-2).join('.');
  Cookies.set('companyId', window.urlObject?.sysNum, {
    domain: `.${domain}`,
    path: '/',
    expires: 7,
  });
}

// 1. Initialize
const app = dva({
  history: createHistory()
});

// 2. Plugins
// app.use(require());

// 3. Model
app.model(leaveMsg);
app.model(require('./models/app').default);
app.model(require('./models/locale').default);

// 4. Router
app.router(require('./router').default);

// 5. Start

app.start('#root');
